import React from 'react';
import IntroSection from '../components/IntroSection';
import HealthSolutions from '../components/HealthSolutions';
import BlueSectionDivider from '../components/BlueSectionDivider';
import HealthBenefits from '../components/HealthBenefits';
import CountriesSection from '../components/CountriesSection';
import TechStackSection from '../components/TechStackSection';
import HealthFaq from '../components/HealthFaq';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

 const Healthtech=()=>{
    return(
        <div>
            <IntroSection title="LEADING HEALTHCARE TECHNOLOGY SOLUTIONS" paragraph="Innovate with HealthTech, MedTech, and Clinical Software Development Services" backgroundImage = "/images/health-bg.webp"/>
           
            <HealthSolutions/>
            <BlueSectionDivider/>
            <HealthBenefits imageSrc="https://cdn.prod.website-files.com/63d3b504212f2224c6e39423/65830ca3bdbcd77576dee450_Technical%20consultancy%20fintech.png"/>
            <BlueSectionDivider/>
            <CountriesSection/>
            <BlueSectionDivider/>
            <TechStackSection/>
            <BlueSectionDivider/>
            <HealthFaq/>
            <ContactSection backgroundColor="#057af0ff"/>
            <Footer/>


        </div>
    )
 }
 export default Healthtech;